import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router';
import ProductTypeSalesDataGrid from 'components/reports/products/productTypeSales/ProductTypeSalesDataGrid';
import PriceBreakDownFilter from 'components/reports/products/priceBreakDown/PriceBreakDownFilter';
import { toast } from 'react-toastify';
import {
  convertQueryParamsIntoObject,
  convertObjectIntoQueryParams,
  convertToUnix,
  convertFromUnix,
} from 'constant/Helpers';
import cloneDeep from 'lodash/cloneDeep';
// actions
import { setLoaderOpenTrue, setLoaderOpenFalse } from 'store/app/AppActions';
// api
import ProductsReportService from 'services/reportsService/ProductsReportService';
// datadog
import { errorLogger } from 'datadog/DDUtils';

const ProductTypeSalesPage = () => {
  const [data, setData] = useState([]);
  const [inputValues, setInputValues] = useState({
    fromDate: convertToUnix(),
    toDate: convertToUnix(),
    datetype: 0,
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const fetchData = async (params) => {
    dispatch(setLoaderOpenTrue());
    try {
      const res = await ProductsReportService.getProductTypeSales(params);
      setData(res.data);
      dispatch(setLoaderOpenFalse());
    } catch (err) {
      errorLogger('Product Type Sales Report Page Fetch Data Error:', err);
      dispatch(setLoaderOpenFalse());
      toast.error('Failed to get data!!');
    }
  };

  useEffect(() => {
    if (location.search) {
      const queryObj = convertQueryParamsIntoObject(location.search);
      fetchData(queryObj);
    } else {
      fetchData(inputValues);
    }
  }, []);

  const handleSubmit = async () => {
    const updatedParams = cloneDeep(inputValues);
    updatedParams.fromDate = convertFromUnix(inputValues.fromDate);
    updatedParams.toDate = convertFromUnix(inputValues.toDate);
    const queryString = convertObjectIntoQueryParams(updatedParams);
    navigate({
      pathname: '/report/ProductTypeSales',
      search: queryString,
    });
    fetchData(updatedParams);
  };

  return (
    <div className="toolbar-table-style">
      <PriceBreakDownFilter
        inputValues={inputValues}
        setInputValues={setInputValues}
        handleSubmit={handleSubmit}
        productType
        title="Sales Product Type"
      />
      <ProductTypeSalesDataGrid data={data} />
    </div>
  );
};

export default ProductTypeSalesPage;
